import React from 'react';
import { Typography } from '../../components/basic';
import { Container, Grid } from '@mui/material';

const NotFoundPage = () => {
  return (
    <Container>
      <Grid>
        <Typography variant="h2">
          The page you are looking for could not be found!
        </Typography>
      </Grid>
    </Container>
  );
};

export default NotFoundPage;
